import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/index'
import Login from '../views/login'
import Complete from '../views/complete'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'indexBase',
      component: Index
    },
    {
      path: '/index',
      name: 'index',
      component: Index
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/complete',
      name: 'complete',
      component: Complete
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js